import { Amplify } from 'aws-amplify';
import { envConfig } from './environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: envConfig.userPoolId,
      userPoolClientId: envConfig.userPoolClientId,
      identityPoolId: envConfig.identityPoolId,
      loginWith: {
        oauth: {
          domain: `${envConfig.cognitoDomain}.auth.${envConfig.region}.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [envConfig.redirectSignIn],
          redirectSignOut: [envConfig.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
  Storage: {
    S3: {
      buckets: {
        exchangeBucket: {
          bucketName: envConfig.s3BucketName,
          region: envConfig.region,
        },
        validatedProjectBucket: {
          bucketName: envConfig.s3BucketNameValidatedProject,
          region: envConfig.region,
        }
      },

    }
  }
});
